/* eslint-disable react-hooks/set-state-in-effect -- viewport init */
import { useEffect, useState } from 'react';

/**
 * @usage - isMobile()
 * @description - Determines mobile/dekstop screen based on window size
 * @returns {bool} - returns 'true' for mobile screen 'false' for desktop screen
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const MOBILE_BREAKPOINT = 768;

  const handleResize = () => {
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
/* eslint-enable react-hooks/set-state-in-effect */
